module.exports = __webpack_public_path__ + "static/media/maiara.f7673a1f.jpg";